import { Component, OnInit } from '@angular/core';
import { PublicService } from 'src/app/services/public/public.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-admissionopen',
  templateUrl: './admissionopen.component.html',
  styleUrls: ['./admissionopen.component.css']
})
export class AdmissionopenComponent implements OnInit {

  SchoolList=[];

  constructor(private  publicService:PublicService,public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }

  AdmissionOpenModel = {

}

// GetAdmissionProcedure(obj) {
//     var itembo = {
//         'BranchID': obj.BranchID
//     }
//     this.lookupService.GetLookupsList('AdmissionProcedure', JSON.stringify(itembo)).subscribe((data) => {
//       this.AdmissionProcedure = data.LookupItems[1].ItemName;
   
//     });
// }


GetSchoolAccount() {
  this.spinnerService.show();
  this.publicService.GetSchoolAccount().subscribe((data) => {
        this.SchoolList = data.SchoolList;
        this.spinnerService.hide();
        
    });
};
  ngOnInit() {
    this.GetSchoolAccount();
  }


  

}
